import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// import { ThemeProvider, createTheme } from '@mui/material/styles';
// import CssBaseline from '@mui/material/CssBaseline';

// Import the new Theme Provider
import AppThemeProvider from './contexts/ThemeContext.js';

// Pages
import Home from './pages/Home';
import Faculty from './pages/Faculty';
import Services from './pages/Services';
import FeeStructure from './pages/FeeStructure';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import GoogleAnalytics from './components/GoogleAnalytics';

// const theme = createTheme({
//   palette: {
//     mode: 'dark', // Set theme to dark mode
//     primary: {
//       main: '#1a2a3a', // Dark background color from the logo
//     },
//     secondary: {
//       main: '#4fc3f7', // Light blue accent from the logo
//     },
//     error: {
//       main: '#ff6f61', // Red/orange accent from the logo
//     },
//     background: {
//       default: '#121c27', // A slightly darker shade for the main background
//       paper: '#1a2a3a', // Same as primary for consistent dark elements
//     },
//     text: {
//       primary: '#ffffff', // White text for contrast
//       secondary: '#bbbbbb', // Lighter grey for secondary text
//     },
//   },
//   typography: {
//     fontFamily: 'Roboto, Arial, sans-serif',
//     h1: { fontSize: '3.5rem' },
//     h2: { fontSize: '3rem' },
//     h3: { fontSize: '2.5rem' },
//     h4: { fontSize: '2rem' },
//     h5: { fontSize: '1.5rem' },
//     h6: { fontSize: '1.25rem' },
//   },
//   components: {
//     MuiAppBar: {
//       styleOverrides: {
//         root: {
//           backgroundColor: '#1a2a3a', // Match primary color for AppBar
//         },
//       },
//     },
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           textTransform: 'none',
//         },
//         containedSecondary: {
//           backgroundColor: '#4fc3f7', // Light blue accent for contained secondary buttons
//           color: '#121c27',
//           '&:hover': {
//             backgroundColor: '#81d4fa',
//           },
//         },
//       },
//     },
//     MuiCard: {
//       styleOverrides: {
//         root: {
//           backgroundColor: '#1a2a3a', // Match primary color for Card background
//           color: '#ffffff', // White text on cards
//         },
//       },
//     },
//     MuiPaper: {
//       styleOverrides: {
//         root: {
//           backgroundColor: '#1a2a3a', // Match primary color for Paper background
//           color: '#ffffff', // White text on paper
//         },
//       },
//     },
//   },
// });

function App() {
  return (
    <HelmetProvider>
      <AppThemeProvider>
        <Router>
          <GoogleAnalytics />
          <div className="App">
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/faculty" element={<Faculty />} />
                <Route path="/services" element={<Services />} />
                <Route path="/fee-structure" element={<FeeStructure />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </AppThemeProvider>
    </HelmetProvider>
  );
}

export default App; 
